// 综合测评
export default [
    {
        path: '/evaluationHome',
        component: resolve => require(['@/pages/evaluation/evaluationHome.vue'], resolve),
        name: 'evaluationHome',
        meta: {
            title: '综合测评'
        }
    },
    {
        path: '/evaluationWeightSetting',
        component: resolve => require(['@/pages/evaluation/evaluationWeightSetting.vue'], resolve),
        name: 'evaluationWeightSetting',
        meta: {
            title: '综合测评设置'
        }
    },
    {
        path: '/evaluationDetail',
        component: resolve => require(['@/pages/evaluation/evaluationDetail.vue'], resolve),
        name: 'evaluationDetail',
        meta: {
            title: '综合测评详情'
        }
    },
    {
        path: '/qualityDevelopmentMangent',
        component: resolve => require(['@/pages/evaluation/qualityDevelopmentMangent.vue'], resolve),
        name: 'qualityDevelopmentMangent',
        meta: {
            title: '素质拓展管理'
        }
    },
    {
        path: '/addQualityDevelopment',
        component: resolve => require(['@/pages/evaluation/addQualityDevelopment.vue'], resolve),
        name: 'addQualityDevelopment',
        meta: {
            title: '素质拓展新增'
        }
    },
    {
        path: '/evaluationFile',
        component: resolve => require(['@/pages/evaluation/evaluationFile.vue'], resolve),
        name: 'evaluationFile',
        meta: {
            title: '查看文件'
        }
    },
    {
        path: '/evaluationHome',
        component: resolve => require(['@/pages/evaluation/evaluationHome.vue'], resolve),
        name: 'evaluationHome',
        meta: {
            title: '综合测评'
        }
    },
    {
        path: '/evaluationArchiveList',
        component: resolve => require(['@/pages/evaluation/evaluationArchiveList.vue'], resolve),
        name: 'evaluationArchiveList',
        meta: {
            title: '综合测评档案管理'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/evaluation.js